"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDiaperFunds = void 0;
var graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.GetDiaperFunds = (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query {\n    account {\n      diaperBanks {\n        slug\n        babyName\n        balance\n        giftCode\n        fundsRaised\n        profileImgUrl\n        publicUrl\n      }\n    }\n  }\n"], ["\n  query {\n    account {\n      diaperBanks {\n        slug\n        babyName\n        balance\n        giftCode\n        fundsRaised\n        profileImgUrl\n        publicUrl\n      }\n    }\n  }\n"])));
var templateObject_1;
